import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  color: "#161616"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 1.625A6.375 6.375 0 1 0 14.375 8 6.383 6.383 0 0 0 8 1.625m0 12A5.625 5.625 0 1 1 13.625 8 5.63 5.63 0 0 1 8 13.625M10.875 8a.375.375 0 0 1-.375.375H8.375V10.5a.375.375 0 0 1-.75 0V8.375H5.5a.375.375 0 0 1 0-.75h2.125V5.5a.375.375 0 1 1 .75 0v2.125H10.5a.375.375 0 0 1 .375.375"
    }, null, -1)
  ]))]))
}
export default { render: render }